const Productdetails=[
    {
        id:1,
        name:"Sansevieria",
        Price:600,
        image:require('./images/sansevieria.jpg'),
        count:1,
        total:600
    },
    {
        id:2,
        name:"Opuntia",
        Price:275,
        image:require('./images/opuntia.jpg'),
        count:1,
        total:275
    },
    {
        id:3,
        name:"Anthurium",
        Price:750,
        image:require('./images/anthurium.jpg'),
        count:1,
        total:750
    },
    {
        id:4,
        name:"dracaena",
        Price:612,
        image:require('./images/dracaena.jpg'),
        count:1,
        total:612
    },
    {
        id:5,
        name:"Codiaeum",
        Price:450,
        image:require('./images/codiaeum.jpg'),
        count:1,
        total:450
    },
    {
        id:6,
        name:"Gerber Daisy",
        Price:450,
        image:require('./images/gerberdaisy.jpg'),
        count:1,
        total:450
    },
    {
        id:7,
        name:"Aloe Vera",
        Price:270,
        image:require('./images/aloevera.jpg'),
        count:1,
        total:270
    },
    {
        id:8,
        name:"String of Pearls",
        Price:190,
        image:require('./images/stringofpearls.jpg'),
        count:1,
        total:190
    },
    {
        id:9,
        name:"Jasmine",
        Price:325,
        image:require('./images/jasmine.jpg'),
        count:1,
        total:325
    },
]
export default Productdetails